import { Box, DashboardModule, SectionDivider } from '@domain-group/suit-theme'

import { categoriseAdAccountGroupAdAccounts } from '@functions/adAccountGroupAdAccount'

import useAdAccountGroupAdAccounts from '@hooks/useAdAccountGroupAdAccounts'
import useSelector from '@hooks/useSelector'

import { AdAccountGroupModel } from '@models/types'

import AdAccountsModule from './AdAccountsModule'
import SelectAdChannelButton from './SelectAdChannelButton'

type AdAccountsProps = {
  adAccountGroup: AdAccountGroupModel,
}

const AdAccounts = (props: AdAccountsProps) => {
  const { adAccountGroup } = props

  const adAccountGroupAdAccountsPayload = useAdAccountGroupAdAccounts({
    filters: {
      adAccountGroupId: adAccountGroup.id,
    },
    performHttpRequests: true,
    requestOptions: {
      include: 'AdAccount',
    }
  })

  const { filteredAdAccountGroupAdAccounts, loading } = adAccountGroupAdAccountsPayload

  const { adAccounts } = useSelector(reduxState => reduxState.entities)

  const categorisedAdAccountGroupAdAccounts = categoriseAdAccountGroupAdAccounts({
    adAccounts,
    adAccountGroupAdAccounts: filteredAdAccountGroupAdAccounts,
  })

  const { facebook, google } = categorisedAdAccountGroupAdAccounts
  const hasFacebookAdAccounts = !!facebook.length
  const hasGoogleAdAccounts = !!google.length

  return (
    <>
      <SectionDivider>Ad Accounts</SectionDivider>

      {(!loading && !hasFacebookAdAccounts && !hasGoogleAdAccounts) && (
        <DashboardModule title="Ad Channels">
          <DashboardModule.Footer boxProps={{ borderTop: 'none' }}>
            <DashboardModule.FooterRight>
              <SelectAdChannelButton adAccountGroupId={adAccountGroup.id} />
            </DashboardModule.FooterRight>
          </DashboardModule.Footer>
        </DashboardModule>
      )}

      {hasFacebookAdAccounts && (
        <AdAccountsModule
          adAccountGroupAdAccounts={facebook}
          categoryTitle="facebook"
        />
      )}

      {hasGoogleAdAccounts && (
        <AdAccountsModule
          adAccountGroupAdAccounts={google}
          categoryTitle="google"
        />
      )}

      {(hasFacebookAdAccounts || hasGoogleAdAccounts) && (
        <Box
          alignItems={['flex-start', 'center']}
          backgroundColor="white"
          border="1px solid"
          borderColor="lineColor"
          borderRadius={5}
          flexDirection={['column', 'row']}
          justifyContent="end"
          marginBottom="large"
          padding="large"
        >
          <SelectAdChannelButton adAccountGroupId={adAccountGroup.id} />
        </Box>
      )}
    </>
  )
}

export default AdAccounts